module.exports = __webpack_public_path__ + "static/globalscreenshotsettings-5d2da0d9da33137a1c15755a6b514302.png";